import { Component, OnInit, Inject } from '@angular/core';
import { BookService } from 'src/app/api/book.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExtendCalc } from 'src/app/models/api_models/book';
import { Router } from '@angular/router';


export class ExtendConfimData {
  constructor(
    public bookId : number,
    public start : Date,
    public end : Date,
    public oldEnd : Date,
  ) {
    
  }
}

@Component({
  selector: 'app-book-extend-confirm-dialog',
  templateUrl: './book-extend-confirm-dialog.component.html',
  styleUrls: ['./book-extend-confirm-dialog.component.scss']
})
export class BookExtendConfirmDialogComponent implements OnInit {
  public _extend : ExtendCalc = null;
  get extend() : ExtendCalc {return  this._extend;}
  set extend(extend : ExtendCalc) {this._extend = extend;}

  public _start : Date = null;
  public _end  : Date = null;
  public _oldEnd  : Date = null;
  public _bookId : number  = null;

  constructor( public dialogRef: MatDialogRef<BookExtendConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data : ExtendConfimData = null, private bookService : BookService, private router: Router) {
    this._end = data.end;
    this._start = data.start;
    this._bookId = data.bookId;
    this._oldEnd = data.oldEnd
    this.bookService.estimeExtendBook(data.bookId, (data.end.getTime() - data.oldEnd.getTime()) / (1000 * 60) ).subscribe(
      response => {
        this._extend = response;
        // console.log(response);
      }
    );
  }

  cancel() {
    this.dialogRef.close(null);
  }

  confirm() {
    // console.log("OK");
    // console.log(this._oldEnd);
    // console.log(this._end);
    
    this.bookService.confirmExtendBook(this._bookId, (this._end.getTime() - this._oldEnd.getTime()) / (1000 * 60)).subscribe(
      response => {
        
        this.router.navigate(['/auth/reservation/' + response.id]);
        this.dialogRef.close(response.id);
      }
    )
  }

  ngOnInit() {
  }

}
